export const API = process.env.REACT_APP_BACKEND;
export const IMAGE = process.env.REACT_APP_API_IMAGE
export const PDF = process.env.REACT_APP_INVOICE_PDF_API
export const STRIPEPUBLICKEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY
export const STRIPESECRETKEY = process.env.REACT_APP_STRIPE_SECRET_KEY
export const REDIRECTURL     = process.env.REACT_APP_REDIRECT